import { useDispatch } from 'react-redux';
import useApplicationUid from './useApplicationUid';
import {
  createIraApplicationFundingType,
  updateIraApplicationFundingType,
} from '../store/actions/iraFunding/iraFundingActions';
import useIraApplicationFundingData from './useApplicationIraFundingData';
import { IRA_APPLICATION_FUNDING_TYPES } from '../util/constants';
import { parseEnumType } from '../util/helpers/enumMappers';

const useIraApplicationFundingTypeDispatch = () => {
  const dispatch = useDispatch();
  const { ApplicationUid } = useApplicationUid();
  const { IraApplicationFundingResponse } = useIraApplicationFundingData();

  const iraApplicationFundingTypeDispatch = ({ data, onSuccess, onError }) => {
    const shouldSkip =
      parseEnumType(
        IRA_APPLICATION_FUNDING_TYPES,
        IraApplicationFundingResponse?.IRAFundingType,
      ) === data?.IRAFundingType;

    if (shouldSkip) {
      onSuccess();
      return;
    }

    if (IraApplicationFundingResponse?.IRAFundingType) {
      dispatch(
        updateIraApplicationFundingType({
          ApplicationUid,
          params: { IRAFundingType: data.IRAFundingType },
          onSuccess,
          onError,
        }),
      );
    } else {
      dispatch(
        createIraApplicationFundingType({
          ApplicationUid,
          params: { IRAFundingType: data.IRAFundingType },
          onSuccess,
          onError,
        }),
      );
    }
  };

  return { iraApplicationFundingTypeDispatch };
};

export default useIraApplicationFundingTypeDispatch;
